<template>
    <div class="components-awards-box">
        <div class="box-title">
            <img :src="props.data.icon" alt="" />
            <div class="text">{{props.data.title }}</div> 
        </div>
        <div class="box-list">
            <div class="list-item" v-for="item in props.data.list" :key="item.title">
                <div class="item-title">
                    <img class="left" src="https://p4.ssl.qhimg.com/t110b9a9301bd23d4114049a920.png" alt="" />
                    <div class="text">{{item.title}}</div>
                    <img class="right" src="https://p5.ssl.qhimg.com/t110b9a9301befa05040a514034.png" alt="" />
                </div>
                <div class="item-content">
                    {{item.desc}}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
</script>

<style lang="scss" scoped>
.components-awards-box{
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 56px;
    .box-title{
        display: flex;
        align-items: center;
        img{
            width: 22px;
            height: 22px;
        }
        .text{
            color: rgb(38, 38, 38);
            font-family: 阿里巴巴普惠体 2.0;
            font-size: 20px;
            font-weight: 700;
            letter-spacing: 0px;
            margin-left: 12px;
        }
    }
    .box-list{
        display: flex;
        flex-direction: column;
        margin-top: 24px;
        .list-item{
            width: 100%;
            padding: 24px;
            border-radius: 8px;
            background: rgb(255, 255, 255);
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 18px;
            .item-title{
                display: flex;
                align-items: center;
                .left{
                    height: 26px;
                    width: 10px;
                }
                .right{
                    height: 26px;
                    width: 10px;
                }
                .text{
                    color: rgb(30, 89, 191);
                    font-family: 阿里巴巴普惠体 2.0;
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 20px;
                    letter-spacing: 0px;
                    margin-left: 10px;
                    margin-right: 10px;
                }
            }
            .item-content{
                color: rgb(38, 38, 38);
                font-family: 阿里巴巴普惠体 2.0;
                font-size: 12px;
                font-weight: 300;
                line-height: 22px;
                letter-spacing: 0px;
                margin-top: 16px;
                text-align: justify;
            }
            &:last-child{
                margin-bottom: 0px;
            }
        }
    }
}
</style>
